import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { SECUREPAY_SHARED_CONFIG } from '../config/securepay-shared-config';
import { ApiResponse } from '../models/securepay';
import {
  IntegrationChecklistData,
  RunTestSuiteResult,
  WebhookConfigResult,
} from './integration-checklist.model';

@Injectable({ providedIn: 'root' })
export class IntegrationChecklistService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(SECUREPAY_SHARED_CONFIG);

  getChecklist() {
    return this.http.get<ApiResponse<IntegrationChecklistData>>(
      `${this.config.apiBaseUrl}/api/IntegrationChecklist`,
    );
  }

  completeStep(action: string, body: Record<string, unknown> = {}) {
    return this.http.post<ApiResponse<IntegrationChecklistData>>(
      `${this.config.apiBaseUrl}/api/IntegrationChecklist/${action}`,
      body,
    );
  }

  configureWebhook(payload: { webhookUrl: string }) {
    return this.http.post<ApiResponse<WebhookConfigResult>>(
      `${this.config.apiBaseUrl}/api/IntegrationChecklist/webhook-config`,
      payload,
    );
  }

  runTestSuite() {
    return this.http.post<ApiResponse<RunTestSuiteResult>>(
      `${this.config.apiBaseUrl}/api/IntegrationChecklist/run-test-suite`,
      {},
    );
  }

  submitTestSuite(file: File, notes: string) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('notes', notes.trim() || 'none');

    return this.http.post<ApiResponse<IntegrationChecklistData>>(
      `${this.config.apiBaseUrl}/api/IntegrationChecklist/submit-test-suite`,
      formData,
    );
  }

  activateSandbox() {
    return this.http.post<ApiResponse<unknown>>(
      `${this.config.apiBaseUrl}/api/Sandbox/activate`,
      {},
    );
  }
}
